module.exports = __webpack_public_path__ + "img/news-4.a1e12226.jpg";